import { SendEmailStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { removeGenericFromType } from "@redotech/redo-flows-core-schema-common/type-system/data-types/generic-types";
import { Schema } from "@redotech/redo-flows-core-schema-common/type-system/schema";
import { FrontendStepType, PartialWithRequiredType } from "../steps";
import { SendEmailTemplatePreview } from "./send-email-template-preview";

export const getDefaultEmailAddressFieldName = (schema: Schema) => {
  return Object.keys(schema.fields).find(
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    (key) => removeGenericFromType(schema.fields[key].dataType) === "Email",
  );
};

export const getDefaultEmailRecipientNameFieldName = (schema: Schema) => {
  return Object.keys(schema.fields).find(
    (key) =>
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      removeGenericFromType(schema.fields[key].dataType) === "Name" ||
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      (removeGenericFromType(schema.fields[key].dataType) === "Text" &&
        key.toLowerCase().includes("firstname")),
  );
};

export function isNameField(fieldName: string, schema: Schema) {
  return (
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    removeGenericFromType(schema.fields[fieldName].dataType) === "Name" ||
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    (removeGenericFromType(schema.fields[fieldName].dataType) === "Text" &&
      fieldName.toLowerCase().includes("name"))
  );
}

export const validateSendEmailStep = (
  step: PartialWithRequiredType<SendEmailStep>,
) => {
  return !!step.templateId || !!step.originTemplateId;
};

export const sendEmailStepType: FrontendStepType<
  PartialWithRequiredType<SendEmailStep>
> = {
  valid: validateSendEmailStep,
  type: "custom",
  customInspector: (props) => <SendEmailTemplatePreview {...props} />,
};
